/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import Sample from 'repos/Sample.js';
import Waveform from 'components/Waveform.js';
import { withRouter } from 'react-router';
import Tone from 'tone';
import axios from 'axios';
import YoutubeInfo from 'components/Youtube.js';
import { Badge, Card, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import AudioUnit from 'engine/audio.js';
import createHistory from "history/createBrowserHistory"

var AudioContext = window.AudioContext || window.webkitAudioContext;
var audioCtx = new AudioContext();

class SampledSound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            soundId: props.soundId,
        };
        this.audioUnit = new AudioUnit(audioCtx);
        this.loadBuffer.bind(this);
        this.handleLoadBuffer.bind(this);
        this.loadBuffer();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.soundId !== this.state.soundId) {
            this.state.soundId = nextProps.soundId;
            this.loadBuffer();
        }

        return true;
    }
    
    loadBuffer() {
        var self = this;
        console.log('loading buffer soundId = '+ this.props.soundId);
        this.sample = new Sample(this.props.soundId, this.props.encryptedIpfs);
        this.sample.name = this.props.title;
        this.sample.videoId = this.props.videoId;
        this.state.name = this.props.title;
        this.state.videoId = this.props.videoId;
        console.log('gonna fetch audio for id = ' + this.sample.getId());
        this.sample.fetchAudio()
            .then((sample) => {
                this.audioUnit.setBuffer(sample.audioBuffer);
                this.state.buffer = sample.audioBuffer;
                this.setState(this.state);
            });
   }

    handleLoadBuffer(self, buffer) {
        var state = self.state;
        state['buffer'] = buffer;
        self.setState(state);
    }
    
    render() {
        var self = this;
        if (this.state.buffer != undefined) {
            return (
                <div className={this.props.isSelected ? 'selected sound-row' : "sound-row"}>
                    <div className="playlist-row">
                      <Waveform selections={[]}
                                sample={this.sample}
                                store={this.props.store}
                                buffer={this.audioUnit.buffer}
                                onClickSelection={(id, buffer) => []}
                        height={70}
                        width={350}
                        onSelection={(start, end) => []}
                        audioUnit={this.audioUnit}
                        waveformId={0}></Waveform>
                      <div className="youtube-info">
                            <YoutubeInfo onClickThumbnail={() => this.props.onClickThumbnail(this.state.soundId)}
                              coverArt={this.props.coverArt}
                                  sample={this.sample}
                                  name={this.props.title}
                                  isMuted={false}
                                  soundId={this.state.soundId} 
                                  onNewSound={this.props.onNewSound} 
                                  videoId={this.state.videoId}>
                        </YoutubeInfo>
                      </div>
                      <div
                        onClick={this.props.onDelete}
                        className="delete-button">x</div>
                    </div>
                    {this.props.tags != null ? this.props.tags.map((tag) =>
                      <Badge
                        onClick={() => this.props.onDeleteTag(tag)}
                        color="light">{tag}</Badge>) : ''}
                </div>
                    );
        } else {
            return (<div></div>);
        }
    }
}

export default SampledSound;
